import React, { useState, useEffect, useContext } from "react";
import { jwtDecode } from "jwt-decode";
import {
  getCustomers,
  getMyCustomers,
  addCustomer,
  updateCustomer,
  deleteCustomer,
} from "../../api/Customer/customerApi";
import CustomerList from "./CustomerList";
import Box from "@mui/material/Box";
import { SidebarContext } from "../../components/Sidebar/SidebarProvider";

const CustomerPage = () => {
  /* const { isMinimized } = useContext(SidebarContext);
  const marginLeft = isMinimized ? "4em" : "15em"; */
  const { contentMargin } = useContext(SidebarContext);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    try {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const isAdmin = decoded.isAdmin;

      const data = isAdmin ? await getCustomers() : await getMyCustomers();
      setCustomers(data);
    } catch (error) {
      console.error("❌ Error cargando clientes:", error);
    }
  };

  const handleAdd = async (customer) => {
    await addCustomer(customer);
    loadCustomers();
  };

  const handleEdit = async (id, updatedCustomer) => {
    await updateCustomer(id, updatedCustomer);
    loadCustomers();
  };

  const handleDelete = async (id) => {
    await deleteCustomer(id);
    loadCustomers();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100dvh",
        boxSizing: "border-box",
        overflow: "auto",
        pt: 2,
        pl: { xs: 1.25, sm: 2 },
        pr: { xs: 1.25, md: 3 },
        pb: { xs: 10, sm: 2 },
        ...contentMargin,
      }}
    >
      <CustomerList
        customers={customers}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </Box>
  );
};

export default CustomerPage;
